export class ProcessElementSearchDto {
  processIds?: number[];
  activityIds?: number[];
  taskIds?: number[];
  nodeConfigurationType?: NodeConfigurationType;
}

export class ProcessElementSearchDtoWrapper {
  processIds?: ElementIdWrapper[];
  activityIds?: ElementIdWrapper[];
  taskIds?: ElementIdWrapper[];
}

export class ElementIdWrapper {
  elementId: number;
  elementCompositeId: string;
}

export enum NodeConfigurationType {
  All = 'All',
  Standard = 'Standard',
  Qa = 'Qa'
}
